var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"btn-table-options my-4",attrs:{"color":"grey lighten-2 pa-0","x-small":"","elevation":"0","width":"40px","height":"40px"}},'v-btn',attrs,false),on),[_c('v-icon',{},[_vm._v("mdi-dots-vertical")])],1)]}}])},[_c('TableActionOptions',{attrs:{"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }